export const contentData = {
  spanish:{
    error:'',
    save_button:'Actualizar',
    layout:{
      title:'Cambiar contraseña',
      navigation:[
        {name:'Perfil',path:'/profile'},
        {name:'Contraseña',path:'/profile/change-password'},
      ]
    },
    basicForm:{
        password:{
            label:'Nueva Contraseña',
            placeholder:'Nueva Contraseña'
        }
    }
  }
}
